import { useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import EcomEngineAPI from 'api/ecom_engine_api';
import ConfirmPasswordField from 'components/formik/confirm_password_field';
import ProgressButton from 'components/progress_button/progress_button';
import SetPasswordSucceed from './set_password_succeed';

const SetPassword = () => {
  const [submissionMessage, setSubmissionMessage] = useState('');
  const [isSubmissionSucceed, setIsSubmissionSucceed] = useState();
  const [submissionClass, setSubmissionClass] = useState('alert-info');

  const onSubmit = ({ newPassword }, { setSubmitting, isSubmitting }) => {
    if (isSubmitting) {
      return;
    }
    setSubmitting(true);
    setSubmissionMessage(null);
    setSubmissionClass('alert-info');

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get('token');

    EcomEngineAPI.account
      .setPassword({
        password: newPassword,
        token,
      })
      .then((result) => {
        setSubmitting(false);

        if (result.message) {
          setSubmissionClass('alert-danger');
          setSubmissionMessage(result.message);
        }

        if (result.success) {
          setIsSubmissionSucceed(true);
        }
      });
  };

  const formSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required('Password is required')
      .matches(/^.{8,}$/, 'Must contain 8 characters'),
    confirmNewPassword: Yup.string()
      .required('Passwords must match')
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
  });

  if (isSubmissionSucceed) {
    return <SetPasswordSucceed />;
  }

  return (
    <div className="container container--x-narrow py-primary">
      <h3 className="mb-3">Set a new password</h3>

      <Formik
        initialValues={{
          newPassword: '',
          confirmNewPassword: '',
        }}
        validationSchema={formSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, isValid, dirty }) => (
          <Form>
            {submissionMessage && (
              <div
                className={`alert ${submissionClass} alert-dismissible fade show`}
              >
                {submissionMessage}
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSubmissionMessage(null)}
                />
              </div>
            )}
            <div className="mb-3">
              <ConfirmPasswordField
                passwordName="newPassword"
                confirmPasswordName="confirmNewPassword"
              />
            </div>
            <ProgressButton
              type="submit"
              defaultText="Set password"
              loading={isSubmitting}
              loadingText="Setting password..."
              succeeded={isSubmissionSucceed}
              succeededText="Password set"
              isDisabled={!isValid || !dirty}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SetPassword;
